import { useTracking } from '@vp/react-tracking';
import React, { HTMLProps, PropsWithChildren } from 'react';
import { Button, Link } from '@vp/swan';
import { __, __vistaRoute } from '@99designs/i18n';
import { NEW_PROJECT_ROUTE } from '../../utils/constants';
import { transformToAnalyticsUrl } from '../../utils/transformToAnalyticsUrl';

/**
 * A hardcoded position value for the footer "see all designs" CTA.
 */
const SEE_ALL_DESIGNS_POSITION = 11;

export default function SeeAllDesignsButton() {
    const { tracking } = useTracking();
    const sourceUrl = window.location.pathname;
    const destinationUrl = __vistaRoute(NEW_PROJECT_ROUTE);
    const normalizedDestinationUrl = transformToAnalyticsUrl(destinationUrl);
    const destinationPageName = 'Design Services:Printed Product Brief';
    const ctaValue = `expertServices-${destinationPageName}-startAProject`;
    const sendSeeAllDesignOptions = () => {
        tracking.track('Fly-Out Clicked', {
            action: 'Fly-Out Clicked',
            category: 'Fly-Out',
            label: 'My Design Services:Fly-Out',
            eventDetail: `${sourceUrl}:${normalizedDestinationUrl};My Design Service flyout CTA;${ctaValue}`,
            navigationDetail: `${ctaValue}:${SEE_ALL_DESIGNS_POSITION}`,
            pageSection: 'Design Services',
            pageStage: 'My Account',
            pageName: 'Design Services:Dashboard',
        });
    };
    return (
        <Button
            skin="primary"
            width="full-width"
            render={(props: PropsWithChildren<HTMLProps<HTMLElement>>) => {
                return (
                    <Link
                        to={destinationUrl}
                        className={props.className}
                        onClick={sendSeeAllDesignOptions}
                    >
                        {props.children}
                    </Link>
                );
            }}
        >
            {__('See all design options')}
        </Button>
    );
}
